// apps/client/src/ui/screens/deleteAccount.tsx (M2-T08, spec §10.2, §11) — in-app account deletion, opened from Settings. The submit
// button stays disabled until the player ticks the explicit confirmation; then DELETE /api/me, leave the town and sign out.
import { useState } from 'react';
import { api } from '../../api/endpoints';
import { useCommands } from '../../game/instance';
import { useGame } from '../../state/store';
import { useT } from '../i18n';
import { Panel } from '../kit';
import type { ScreenDef } from '../router';
import { SafetyButton } from './report';

declare module '../router' { interface ScreenParams { deleteAccount: undefined } }

function DeleteAccount({ close }: { params: undefined; close: () => void }) {
  const t = useT();
  const cmd = useCommands();
  const [sure, setSure] = useState(false);
  const [busy, setBusy] = useState(false);
  async function submit() {
    setBusy(true);
    try {
      await api.deleteMe();
    } catch {
      useGame.getState().toast('safety.deleteFailed', undefined, 'warn');
      setBusy(false);
      return;
    }
    if (useGame.getState().townId) cmd.leaveTown();
    useGame.getState().safetyReset();                      // the block list was this account's
    await useGame.getState().signOut();                    // clears the token; phase → signedOut, screens closed
    close();
  }
  return (
    <Panel title={t('safety.deleteTitle')}>
      <div style={{ display: 'grid', gap: 14, width: 'min(480px, 72cqw)', maxWidth: '100%' }}>
        <p style={{ margin: 0 }}>{t('safety.deleteIntro')}</p>
        <label className="hit" style={{ display: 'flex', alignItems: 'center', gap: 10, fontWeight: 800 }}>
          <input type="checkbox" data-testid="delete-confirm" checked={sure} onChange={(e) => setSure(e.target.checked)}
            style={{ accentColor: 'var(--leaf-700)', width: 26, height: 26, flex: 'none' }} />
          {t('safety.deleteConfirm')}
        </label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          <SafetyButton testId="delete-submit" disabled={!sure || busy} onClick={() => void submit()}>{t('safety.deleteSubmit')}</SafetyButton>
          <SafetyButton variant="quiet" onClick={close}>{t('common.cancel')}</SafetyButton>
        </div>
      </div>
    </Panel>
  );
}
export const screen: ScreenDef<'deleteAccount'> = { id: 'deleteAccount', layer: 'panel', component: DeleteAccount };
